var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirect-container"},[_c('div',{staticClass:"loading"},[_c('p',[_vm._v("授权中，请稍候...")])])])}]

export { render, staticRenderFns }